import React, { useEffect, useMemo } from 'react';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { formatFileSize, kindOfFile } from './utils';

const AttachmentPreview = ({ file, onRemove }) => {
  const previewUrl = useMemo(() => {
    if (!file || kindOfFile(file) !== 'image') return null;
    return URL.createObjectURL(file);
  }, [file]);

  useEffect(() => {
    return () => {
      if (previewUrl) URL.revokeObjectURL(previewUrl);
    };
  }, [previewUrl]);

  if (!file) return null;

  return (
    <div className="flex items-center gap-3 rounded-xl border border-gray-200 bg-gray-50 p-2">
      {previewUrl ? (
        <img src={previewUrl} alt="" className="h-14 w-14 rounded-lg object-cover shrink-0" />
      ) : (
        <div className="h-14 w-14 rounded-lg bg-gray-200 flex items-center justify-center shrink-0 text-xl">📎</div>
      )}
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium text-gray-800">{file.name}</p>
        <p className="text-xs text-gray-500">{formatFileSize(file.size)}</p>
      </div>
      <button
        type="button"
        onClick={onRemove}
        className="shrink-0 p-1 rounded-full hover:bg-gray-200"
        aria-label="Убрать вложение">
        <CloseOutlinedIcon fontSize="small" />
      </button>
    </div>
  );
};

export default AttachmentPreview;
